// extracted by mini-css-extract-plugin
export default {"Dots":"dots_Dots__1Cg+v","Dot":"dots_Dot__Zr+-f","blink":"dots_blink__KTHLX"};